module.exports = __webpack_public_path__ + "img/public/SiteIcons/editStepThree.svg?636149a5";